import type { JSX } from '@builder.io/qwik';
import { useContext } from '@builder.io/qwik';
import { useSignal } from '@builder.io/qwik';
import { Slot } from '@builder.io/qwik';
import { component$ } from '@builder.io/qwik';
import { cva } from 'class-variance-authority';
import { AppDataContext } from '~/contexts/AppDataContext';
import Controls from '~/components/Shared/Carousel/Controls';

const tagWrapClasses = cva('relative', {
  variants: {
    hasBefore: {
      true: "before:bg-gradient-to-r before:from-white before:to-white/0 before:[content:''] before:absolute before:top-0 before:left-0 before:h-full before:w-20",
    },
    hasAfter: {
      true: "after:bg-gradient-to-l after:from-white after:to-white/0 after:[content:''] after:absolute after:top-0 after:right-0 after:h-full after:w-20",
    },
  },
});

const scrollContainerClasses = cva('flex gap-2 scroll-smooth no-scrollbar', {
  variants: {
    isMobileViewer: {
      true: 'overflow-x-auto',
      false: 'overflow-x-hidden',
    },
  },
});

export default component$((): JSX.Element => {
  const {
    payloadToSSR: { isMobileViewer },
  } = useContext(AppDataContext);
  const scrollContainer = useSignal<Element | undefined>();
  const showLeftArrow = useSignal(false);
  const showRightArrow = useSignal(false);

  return (
    <div
      class={tagWrapClasses({
        hasBefore: showLeftArrow.value,
        hasAfter: showRightArrow.value,
      })}
    >
      {!isMobileViewer && (
        <Controls
          scrollContainer={scrollContainer}
          showLeftArrow={showLeftArrow}
          showRightArrow={showRightArrow}
        />
      )}
      <div
        ref={scrollContainer}
        class={scrollContainerClasses({ isMobileViewer })}
      >
        <Slot />
      </div>
    </div>
  );
});
